<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <div class="clear">
      <el-col :span="24">
        <el-form-item label="请假人">
          <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="联系方式">
          <el-input size="small" :disabled="true" v-model="userData.mobile"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="参加工作">
          <el-date-picker style="width:100%;" :editable="false" size="small" value-format="yyyy-MM-dd"
            v-model="form.applyTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
    </div>

    <div class="clear">
      <el-col :span="24">
        <el-form-item label="请假类别">
          <el-select style="width:100%;" size="small" v-model="form.type" placeholder="请选择请假类别">
            <el-option v-for="item in typeArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item label="已请年休假" v-if="form.type=='年休假'">
          <el-input size="small" style="width:150px;" :disabled="true" v-model="form.leaveDays"></el-input>
          天
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-form-item label="请假时间">

        <div class="data-time-m">
          <el-input size="small" placeholder="选择开始时间" type="text" v-model="form.startTime" />
          <div class="mask" @click="toggleDateTime('startT')">选择开始时间</div>
          <mt-datetime-picker ref="startT" v-model="startDate" type="datetime"
            @confirm="dateTimeHandleConfirm('start')"></mt-datetime-picker>
        </div>
        <div class="data-time-m">
          <el-input size="small" placeholder="选择结束时间" type="text" v-model="form.endTime" />
          <div class="mask" @click="toggleDateTime('endT')">选择开始时间</div>
          <mt-datetime-picker ref="endT" v-model="endDate" type="datetime"
            @confirm="dateTimeHandleConfirm('end')"></mt-datetime-picker>
        </div>

        <!-- <el-date-picker style="width:100%;" :editable="false" size="small" value-format="yyyy-MM-dd HH:mm:ss"
          v-model="form.startTime" type="datetime" placeholder="选择开始时间">
        </el-date-picker>
        <el-date-picker style="width:100%;" :editable="false" size="small" value-format="yyyy-MM-dd HH:mm:ss"
          v-model="form.endTime" type="datetime" placeholder="选择结束时间">
        </el-date-picker> -->

        共<el-input type="number" size="small" style="width:50px;margin:0 5px;" v-model="form.totalTime"></el-input>天
      </el-form-item>
    </div>

    <el-form-item label="请假原因">
      <el-input style="width:100%;" type="textarea" placeholder="请假原因说明" :autosize="{ minRows: 5, maxRows: 8}"
        size="small" v-model="form.content"></el-input>
    </el-form-item>

  </section>
</template>

<script>
  export default {
    props: ['formByFather', 'userData', 'teamArr', 'projectArr'],
    data() {
      return {
        form: {},
        typeArr: ['公出', '调休', '病假', '事假', '年休假', '其他', ],
        leaveDays: '',

        startDate: new Date(),
        endDate: new Date(),
      }
    },
    created() {
      this.getLeaveDays()
    },
    mounted() {
      this.form = this.formByFather

      this.form.depId = this.userData.secDepIds.split(",")[0]
      this.form.leaderId = this.userData.id
      this.form.leaveDays = this.leaveDays

      if (this.userData.joinTime && !this.form.applyTime) {
        this.form.applyTime = this.formatData(this.userData.joinTime)
      }


    },
    methods: {
      // 打开关闭时间选择器
      toggleDateTime(type) {
        if (type == 'startT') {
          this.$refs.startT.open();
        } else {
          this.$refs.endT.open();
        }
      },
      // 保存时间
      dateTimeHandleConfirm(type) {
        if (type == 'start') {
          this.form.startTime = window.util.getFormatDate(this.startDate.getTime(), true)
        } else {
          this.form.endTime = window.util.getFormatDate(this.endDate.getTime(), true)
        }
      },


      // 获取已请年假天数
      getLeaveDays() {
        ajax.get('/human/leave/days', '', res => {
          this.form.leaveDays = this.leaveDays = res.vo.data
        })
      },

      formatData(data) {
        let _data = ''
        if (data.split("-").length != 3) {
          let _d = data.split("-")
          _data += _d[0] + '-'
          _data += _d[1] ? _d[1] : '01'
          _data += _d[2] ? _d[2] : '01'
        } else {
          _data = data
        }
        return _data
      },

      getFromData() {
        // if (this.form.time) {
        //   this.form.startTime = this.form.time[0]
        //   this.form.endTime = this.form.time[1]
        // }
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
        this.form.leaveDays = this.leaveDays
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/personnel/createVacationApproval_m.vue